<form [formGroup]="form">
  <label class="fw-bold margin-bottom-sm" [for]="domID">
    {{ label | translate }}
    @if (required) {
      <span class="filter-select-required" aria-hidden="true">*</span>
    }
  </label>
  <select class="w-100 form-select" [id]="domID" [formControlName]="field" [style.height.rem]="2.625">
    @for (option of options; track $index) {
      <option [ngValue]="option.value">{{ option.label | translate }}</option>
    }
  </select>
</form>
